import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getData } from "../../../services/library";
import EvaluacionesMedicaItem from "./EvaluacionesMedicasItem";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Container,
  Typography,
} from "@mui/material";
import CandidatoInfo from "../candidatos/CandidatoInfo";
import Navbar from "../../Navbar";
import { logEventos } from "../../../services/services";
const EvaluacionById = () => {
  const { id } = useParams();

  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [mostrarAlerta, setMostrarAlerta] = useState(false);

  const [evaluaciones, setEvaluaciones] = useState([]);
  const [candidatos, setCandidatos] = useState({});

  const rrhh = localStorage.getItem("adminrrhh");

  const getEvaluaciones = useCallback(() => {
    getData(`/SP_evaluaciones/getEvaluacionesPendientes/me/${rrhh}`, (data) => {
      setEvaluaciones(
        [...data].sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
      );
    });
  }, [rrhh]);

  const getCandidatos = useCallback(() => {
    getData(`/SP_candidatos/${id}`, setCandidatos);
  }, [rrhh]);

  useEffect(() => {
    getEvaluaciones();
    getCandidatos();
  }, [getEvaluaciones, getCandidatos]);

  const mostrarAlertaTemporal = (message, severity) => {
    setMostrarAlerta(true);
    setMessage(message);
    setSeverity(severity);

    setTimeout(() => {
      setMostrarAlerta(false);
    }, 5000);
  };

    useEffect(() => {
    logEventos(
      "acceso al menu panel medicina laboral",
      "Evaluaciones medicas",
      " get Evaluaciones medicas",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <>
      {mostrarAlerta && (
        <Alert
          severity={severity}
          sx={{
            zIndex: 1600,
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "auto",
            borderRadius: "8px",
            backgroundColor:
              severity === "success"
                ? "#d8e6d3"
                : severity === "error"
                ? "#efc3c3"
                : severity === "warning"
                ? "#f0efb6"
                : "#e6e6e6",
          }}
        >
          {message}
        </Alert>
      )}
      <Navbar />
      <Container
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 1200,

            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 2,
            margin: "auto",
            overflowY: "auto",
          }}
        >
          <CandidatoInfo candidato={candidatos[0]} />
          {evaluaciones.length === 0 ? (
            <>
              <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
                No hay evaluaciones
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
                Evaluaciones medicas
              </Typography>

              <Box
                sx={{
                  margin: "auto",
                  display: "grid",
                  gap: 2,
                  gridTemplateColumns: "repeat(3, 1fr)",
                  padding: 2,
                  maxHeight: "60vh",//1vh = 1% del alto del viewport por si cambian de monitor
                  overflow: "auto",
                  border: "1px solid #ccc",
                  borderRadius: 1,
                }}
              >
                {evaluaciones.map((evaluacion) => (
                  <EvaluacionesMedicaItem
                    key={evaluacion.id}
                    id={evaluacion.id}
                    id_candidato={evaluacion.id_candidato}
                    prestador={evaluacion.prestador}
                    fecha={evaluacion.fecha}
                    aprobado_parte_rrhh={evaluacion.aprobado_parte_rrhh}
                    aprobado_parte_medico={evaluacion.aprobado_parte_medico}
                    uuid={evaluacion.uuid}
                    user={evaluacion.user}
                    username={evaluacion.username}
                    usersurname={evaluacion.usersurname}
                    nombre={evaluacion.nombre}
                    apellido={evaluacion.apellido}
                    mostrarAlertaTemporal={mostrarAlertaTemporal}
                    getEvaluaciones={getEvaluaciones}
                    total_archivos={evaluacion.total_archivos}
                  />
                ))}
              </Box>
            </>
          )}
        </Box>
      </Container>
    </>
  );
};

export default EvaluacionById;
